export default __webpack_public_path__ + "static/media/press.5d31c6ac.jpg";